import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


const CustomSectionStickyHeadingInner = ({ children, className }) => (
  <div
    className={classNames(
      'custom-section__sticky-heading__inner',
      className,
    )}
  >
    {children}
  </div>
);

CustomSectionStickyHeadingInner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

CustomSectionStickyHeadingInner.defaultProps = {
  children: undefined,
  className: undefined,
};

export default CustomSectionStickyHeadingInner;
